import React, { useEffect, useState } from 'react'
import settingsImg from '../../../assets/images/Topbar/settingsImg.svg'
import notificationImg from '../../../assets/images/Topbar/notificationImg.svg'
import switchTiClient from '../../../assets/images/switch-to-client-image.svg'
import { Dropdown, Modal } from 'react-bootstrap';
import singleUpload from '../../../assets/images/UserManagement/single upload.svg'
import bulkUpload from '../../../assets/images/UserManagement/bulk upload.svg'
import SbCancelBtn, { SBSaveUpdateBtn } from '../../Buttons/Buttons';
import { useNavigate } from 'react-router-dom';
import { postSwitchToSuperAdminDatas } from '../../../redux/action';
import * as HeaderAuthentication from '../../HeaderAuthentication';
import { useDispatch } from 'react-redux';

function Header() {

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedUserName = signInDetails ? signInDetails[0].UserName : null;
    const storedEmail = signInDetails ? signInDetails[0].EmailID : null;
    const signInType = signInDetails ? signInDetails[0].SignInType : null;
    const storedImg = signInDetails ? signInDetails[0].Image : null;
    const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID'));
    const PreviousSuperAdminID = JSON.parse(sessionStorage.getItem('PreviousSuperAdminID'));

    const dispatch = useDispatch();
    const [showDropdown, setShowDropdown] = useState(false);
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [showSwitchModal, setShowSwitchModal] = useState(false);
    const [showCustomerListModal, setShowCustomerListModal] = useState(false);

    const handleDropdownToggle = () => setShowDropdown(!showDropdown);
    const handleProfileDropdownToggle = () => setShowProfileDropdown(!showProfileDropdown);

    const navigate = useNavigate();
    const handleLogoutClick = () => {
        setShowLogoutModal(true); // Show the logout confirmation modal
        setShowProfileDropdown(false); // Close the profile dropdown
    };

    const moduleId = 2;
    const handleSwitchToClient = () => {
        // setShowCustomerListModal(true);
        // e.preventDefault(); // Prevent default anchor behavior
        // window.location.href = '/#/customermanagement'; // Navigate to login-in route
        navigate('/customermanagement', { state: { isSwitchToClient: true, moduleId } })
    };

    const handleNavigateToCustomerConfirm = (e) => {
        e.preventDefault(); // Prevent default anchor behavior
        // window.location.href = '/#/customermanagement'; // Navigate to login-in route
        setShowCustomerListModal(false);
        navigate('/customermanagement', { state: { isSwitchToClient: true, moduleId } })
    }

    const handleSwitchToSuperAdmin = () => {
        setShowSwitchModal(true);
    };
    const handleSwitchClientCancel = () => {
        setShowSwitchModal(false);
    }

    const handleNavigateToCustomerCancel = () => {
        setShowCustomerListModal(false);
    }

    const handleLogoutConfirm = () => {
        sessionStorage.clear(); // Clear session storage
        window.location.href = "/";
    };

    const handleSwitchClientConfirm = (e) => {
        e.preventDefault();

        let SigninID = null;

        if (signInType === "SuperAdmin") {
            SigninID = signInDetails[0].SuperAdminID; // Use SuperAdminID for SuperAdmin type
        } else if (signInType === "ClientAdmin") {
            SigninID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin type
        } else if (signInType === "User") {
            SigninID = signInDetails[0].UserID; // Use UserID for User type
        }

        const data = {
            "SigninID": PreviousSuperAdminID,
            "CompanyID": PreviousCompanyID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };
        dispatch(postSwitchToSuperAdminDatas(requestOption, handleSwitchClientCancel));

    };

    return (
        <div className='header-container'>
            {/* <img src={settingsImg} alt="" /> */}
            {/* Conditionally render the settings image */}
            {signInType !== 'User' && (
                <Dropdown show={showDropdown} onToggle={handleDropdownToggle} className='settings-dropdown'>

                    <Dropdown.Toggle variant="link" className="no-chevron" onClick={handleDropdownToggle}>
                        <img src={settingsImg} alt="Settings" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item href="settings">
                            <img src={singleUpload} alt="" />&nbsp;&nbsp;
                            Settings</Dropdown.Item>
                        {signInType !== 'ClientAdmin' && <Dropdown.Item onClick={handleSwitchToClient}>
                            <img src={bulkUpload} alt="" />&nbsp;&nbsp;
                            Switch to Client</Dropdown.Item>}
                        {PreviousCompanyID && <Dropdown.Item onClick={handleSwitchToSuperAdmin}>
                            <img src={bulkUpload} alt="" />&nbsp;&nbsp;
                            Switch to SuperAdmin</Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>
            )}
            <img src={notificationImg} alt="" />
            {PreviousCompanyID && <img src={switchTiClient} alt="" />}
            {/* <div className='header-profile-div'>
                <img src={profileImg} alt="" />
                <div className='header-user-name'>
                    <span>Thomas Fleming</span>
                    <p>info@gmail.com</p>
                </div>
            </div> */}
            <Dropdown show={showProfileDropdown} onToggle={handleProfileDropdownToggle} className='settings-dropdown'>
                <Dropdown.Toggle variant="link" className="no-chevron" onClick={handleProfileDropdownToggle}>
                    <div className='header-profile-div'>
                        <img
                            // src={profileImg}
                            src={storedImg}
                            alt=""
                            style={{ height: "30px", width: '30px', borderRadius: '50%' }}
                        />
                        <div className='header-user-name'>
                            <span>{storedUserName}</span>
                            <p>{storedEmail}</p>
                        </div>
                    </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item href="userProfile">
                        <img src={singleUpload} alt="" />&nbsp;&nbsp;
                        Profile Settings</Dropdown.Item>
                    <Dropdown.Item onClick={handleLogoutClick}>
                        <img src={bulkUpload} alt="" />&nbsp;&nbsp;
                        Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            <Modal show={showLogoutModal} onHide={() => setShowLogoutModal(false)} className='save-custom-view-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Logout</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to logout?</p>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={() => setShowLogoutModal(false)} />
                    <SBSaveUpdateBtn btnName="Yes" onClickEffect={handleLogoutConfirm} />
                </Modal.Footer>
            </Modal>

            {/* Switch Modal */}
            <Modal show={showSwitchModal} onHide={handleSwitchClientCancel} className='add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Switch to SuperAdmin
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to switch to SuperAdmin
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={handleSwitchClientCancel} />
                    <SBSaveUpdateBtn btnName="Confirm" onClickEffect={handleSwitchClientConfirm} />
                </Modal.Footer>
            </Modal>

            <Modal show={showCustomerListModal} onHide={handleNavigateToCustomerCancel} className='add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Switch to Client
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Select the Customer from the list
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={handleNavigateToCustomerCancel} />
                    <SBSaveUpdateBtn btnName="Ok" onClickEffect={handleNavigateToCustomerConfirm} />
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Header
